import { DbKey } from '../../../../../adl-gen/common/db';
import { Quiz } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import {
  AppUserListEntry,
  RoleBuilderData,
  UserGroupListEntry
} from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { UserQuizChange } from '../../../../stores';
import { ListFieldInfo } from '../../../common/list/list-types';

export type QuizListEntry = { id: DbKey<Quiz>; title: string } & Pick<Quiz, 'imageUrl' | 'workRoleId' | 'workRole' | 'lockResults'>;

/// AppUserListEntry is Partial for new users
export type AppUserListEntryWithQuizChanges = Partial<AppUserListEntry> & { updates: UserQuizChange[] };

// TODO: Might not work as expected
/// Partial for new groups
export type UserGroupListEntryWithQuizChanges = Partial<UserGroupListEntry> & { updates: UserQuizChange[] };

export const AppUserQuizListView: ListFieldInfo<QuizListEntry, AppUserListEntryWithQuizChanges>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'lockResults',
    label: 'Results Locked',
    kind: 'checkItem',
    displayed: true,
    align: 'centre'
  },
  {
    name: 'create',
    label: 'Add',
    kind: 'action-once',
    displayed: true,
    align: 'centre',
    actioned: (entry, data: AppUserListEntryWithQuizChanges) => {
      if (data) {
        // If just created...
        const newlyCreated = data.updates.find(u => u.kind === 'create' && u.value === entry.id);
        // Or existing item not started...
        const existingNotStarted = data.quizzes
          ? data.quizzes.find(q => q.value.quizId === entry.id && q.value.startedAt === null)
          : undefined;
        // ... But not if it's been marked for deletion - should never be 'purge' but jic
        const existingDeleted = existingNotStarted
          ? data.updates.find(u => (u.kind === 'delete' || u.kind === 'purge') && u.value === existingNotStarted.id)
          : undefined;
        return newlyCreated !== undefined || (existingNotStarted !== undefined && existingDeleted === undefined);
      }
      return false;
    }
  }
];

export const UserGroupQuizListView: ListFieldInfo<QuizListEntry, UserGroupListEntryWithQuizChanges>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'lockResults',
    label: 'Results Locked',
    kind: 'checkItem',
    displayed: true,
    align: 'centre'
  },
  {
    name: 'create',
    label: 'Add',
    kind: 'action-once',
    displayed: true,
    align: 'centre',
    //
    actioned: (entry, data) => {
      if (data) {
        const memberIds = data.members ? data.members.map(m => m.value.appUserId) : [];
        // See if everyone has a non-started UQ
        const uqAppUserIdsForQuiz = data.quizzes
          ? data.quizzes
              .filter(uq => uq.value.quizId === entry.id && uq.value.startedAt === null)
              .map(uq => uq.value.appUserId)
              .reduce((acc: string[], next) => {
                if (memberIds.includes(next)) {
                  return acc.includes(next) ? acc : [...acc, next];
                }
                return acc;
              }, [])
          : [];
        const createdUqAppUserIdsForQuiz = data.updates.filter(upd => upd.kind === 'create' && upd.value === entry.id);
        return memberIds.length === 0
          ? false
          : createdUqAppUserIdsForQuiz.length + uqAppUserIdsForQuiz.length === 0
          ? false
          : createdUqAppUserIdsForQuiz.length + uqAppUserIdsForQuiz.length >= memberIds.length;
      }
      return false;
    }
  }
];

export const WorkRoleQuizListView: ListFieldInfo<QuizListEntry, RoleBuilderData>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'workRole',
    label: 'Role',
    kind: 'mapped',
    map: entry => entry.workRole.name,
    displayed: true,
    sortable: true
  },
  {
    name: 'lockResults',
    label: 'Results Locked',
    kind: 'toggle',
    toggle: entry => entry.lockResults,
    displayed: true,
    align: 'centre'
  },
  {
    name: 'attempts',
    label: 'Completed User Attempts',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const quiz = data.quizzes.find(wrq => wrq.quiz.id === entry.id);
        return quiz ? quiz.userQuizzes.filter(uq => uq.value.completedAt !== null).length : 0;
      } else {
        return 'notfound';
      }
    },
    displayed: true,
    sortable: false
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/quiz-list/quiz-list-view.ts